import React from "react";
import SellerLayout from "@/components/layouts/SellerLayout";
import KYCForm from "@/components/KYCForm";

const SellerKYC = () => {
  return (
    <SellerLayout title="KYC Verification">
      <div className="mb-4 p-4 bg-blue-50 border border-blue-100 rounded-xl">
        <p className="text-sm text-blue-800">
          Complete KYC to enable withdrawal of your earnings and unlock full seller features.
        </p>
      </div>
      <KYCForm role="seller" />
    </SellerLayout>
  );
};

export default SellerKYC;
